// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zappyride_incentive_web--Summary-module--cardTagStyles--L7742y7TjHjDL_AcGnN0 > div > div > div {
  background: none;
  padding-left: 0px;
  color: #4d5b6d;
}

.zappyride_incentive_web--Summary-module--cardTagStyles--L7742y7TjHjDL_AcGnN0 > div > div {
  margin-bottom: 0px;
}

.zappyride_incentive_web--Summary-module--cardTagStyles--L7742y7TjHjDL_AcGnN0 h2 {
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/Summary/Summary.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,kBAAA;AAGJ","sourcesContent":[".cardTagStyles > div > div > div {\n    background: none;\n    padding-left: 0px;\n    color: #4d5b6d;\n}\n.cardTagStyles > div > div {\n    margin-bottom: 0px;\n}\n.cardTagStyles h2 {\n    margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardTagStyles": `zappyride_incentive_web--Summary-module--cardTagStyles--L7742y7TjHjDL_AcGnN0`
};
export default ___CSS_LOADER_EXPORT___;
